import ControlProps from '../../../mixins/ControlProps';
import { CardProperty } from '../enums';
import { ControlPropertyType, ControlType } from '../../../enums';

const CardsProps = {
  props: {
    [CardProperty.Name]: ControlProps.props[ControlPropertyType.Name],
    [CardProperty.Value]: ControlProps.props[ControlPropertyType.Value],
    [CardProperty.Disabled]: ControlProps.props[ControlPropertyType.Disabled],
    [CardProperty.Checked]: {
      default: false,
      type: Boolean,
    },
    [CardProperty.Label]: {
      default: '',
      type: String,
    },
    [CardProperty.IsActive]: {
      default: false,
      type: Boolean,
    },
    [CardProperty.ControlType]: {
      default: ControlType.Radio,
      type: String,
    },
  },
};

export default CardsProps;
